import * as Yup from 'yup'

import { EMAIL } from './fields'

const emailValidation = Yup.string()
  .required('This field should not be empty')
  .email('Please enter a valid email address')

export const validationSchema = Yup.object({
  [EMAIL]: emailValidation
})
